module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("NOT READY TO CELEBRATE")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Jocelyn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How long must I wrestle with my thoughts and day after day have sorrow in my heart?")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("PSALM 13:2")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('i', [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("I")])]), _vm._v("’m not ready for this")]), _vm._v(", Laura Slezak thought as she pushed her three-year-old son in the stroller beneath the Florida sun. Beside her, her husband, Craig, pushed their one-year-old daughter Ava, who was recently diagnosed with Angelman syndrome, a complex genetic disorder that includes delayed development, intellectual disability, severe speech impairment, problems with movement and balance, and seizures. Surrounding them were other parents and children with Angelman’s, and supportive friends and family. They were participating in the national walk for the Angelman Syndrome Foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Laura was overwhelmed at the sight of so many older kids with the syndrome all in one place. “One woman told me that she couldn’t believe I was even at the walk, because she had refused to participate soon after her child had been diagnosed,” Laura recalled. “That was so reassuring to me, because I was totally hating being at the walk at that point and wished I hadn’t gone. I needed to know that other moms probably felt the same way at first and that I’m not crazy or a bad mom for being depressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("Another dad told Laura the first two years were the hardest for him, but that it did get better. It was exactly what she needed to hear. “So, it’s OK if I’m not OK with this for another year, even if everyone else thinks that’s a ridiculously long time,” Laura said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Even the most steadfast believers are allowed to own their sorrow. David, a man after God’s own heart (1 Sam. 13:14), expressed grief and dismay in his psalms. Most of his laments reveal that he felt God had deliberately withdrawn his loving protection:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("How long, L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("? Will you forget me forever? How long will you hide your face from me? How long must I wrestle with my thoughts and day after day have sorrow in my heart? (Ps. 13:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("My tears have been my food day and night, while people say to me all day long, “Where is your God?” (Ps. 42:3)")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I am worn out calling for help; my throat is parched. My eyes fail, looking for my God. (Ps. 69:3)")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When Jacob saw his son Joseph’s bloodied and shredded robe, he assumed Joseph was dead. “All his sons and daughters came to comfort him, but he refused to be comforted. ‘No,’ he said, ‘I will continue to mourn "), _c('i', [_vm._v("until I join my son in the grave")]), _vm._v(".’ So his father wept for him” (Gen. 37:35, emphasis added). If this hero of the faith did not give his grief a tight deadline, you don’t need to either.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Mourning a loss of any kind is normal and necessary. When parents learn of their child’s diagnosis, they mourn the child and the future they were expecting to have. “It’s a slow process of adjusting my heart and mind to what IS rather than holding on to what I wanted,” Laura wrote. “I know the more I adjust to and accept reality, the more I will be able to see the good things and the joy God is holding for us in the midst of it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn9",
      "id": "rfn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("In the first year or two of your child’s diagnosis, it may be impossible to imagine feeling any better than you do now. Allow other parents who are further down the road to give you hope. Like David, you’ll be able to end your lament with trust in God’s love (Ps. 13:5) and with hope in him (Ps. 42:11). But in the meantime, it’s OK if you’re not ready to celebrate.")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Lord, thank you for allowing me to grieve without guilt. Help me process this in healthy ways. Please help my spouse and me to be compassionate toward one another, as we may handle our pain in different ways. Bring me to the other side of this grief, as you brought David through his. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Do you feel guilty about how long you’ve been grieving? If so, why?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is one healthy way you can work through your grief?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Can you identify something you should avoid because it only makes you feel worse?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a82ff8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter05.vue
// module id = 96
// module chunks = 0